import {ForwardedRef, forwardRef} from 'react';
import cx from 'classnames';
import {Icon} from '../Icon/Icon';
import {QEPInput} from '../QEPInput/qep-input';
import './Inputfield.scss';

export interface InputfieldProps {
  id?: string;
  value?: string;
  placeholder?: string;
  onChange: (inputValue: string) => void;
  onClickIcon?: () => void;
  canClickIcon?: boolean;
  iconType?: string;
  className?: string;
  disabled?: boolean;
  autoFocus?: boolean;
  allowSpecialCharacters?: boolean;
  maxLength?: number;
}

export const Inputfield = forwardRef(function Inputfield({
  id = '',
  value = '',
  placeholder,
  onChange,
  onClickIcon = () => {},
  canClickIcon = false,
  iconType = 'clear',
  className,
  disabled = false,
  autoFocus = false,
  allowSpecialCharacters = true,
  maxLength = undefined,
}: InputfieldProps, ref: ForwardedRef<HTMLInputElement>) {
  return (
    <div className={cx('qep-inputfield', className)}>
      <QEPInput
        id={id}
        ref={ref}
        type='text'
        value={value}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
        autoFocus={autoFocus}
        allowSpecialCharacters={allowSpecialCharacters}
        maxLength={maxLength}
      />
      {canClickIcon && (
        <Icon
          testId={`${id}-icon`}
          className='overlay-icons right'
          name={iconType}
          onClick={() => onClickIcon()}
        />
      )}
    </div>
  );
});
